class PredictiveSearch extends HTMLElement {
  constructor() {
    super()

    this.input = this.querySelector('input[type="search"]')
    this.predictiveSearchResults = this.querySelector("#predictive-search")
    this.recommendSearchResults = this.querySelector("#recommend-search")
    this.mobileMenuCloseBtn = document.querySelector(".mobile-menu-close-btn")

    this.predictiveSearchNoResults = this.querySelector(".predictive-search-no-results")
    this.isMobile = (function (a) {
      return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))
    })(navigator.userAgent || navigator.vendor || window.opera)
    if (this.isMobile) {
      this.predictiveSearchResults.style.display = "none"
    }
    this.init()

    this.input.addEventListener(
      "input",
      this.debounce((event) => {
        this.onChange(event)
        
      }, 300).bind(this)
    )
  }
  init() {
    var that = this
    that.input.addEventListener("input", function () {
      const searchTerm = that.input.value.trim()
      if (!Boolean(searchTerm)) {
        if (that.recommendSearchResults) {
          that.recommendSearchResults.style.display = that.isMobile ? "none" : "block"
        }
      }
    })

    that.input.addEventListener("focus", function () {
      const searchTerm = that.input.value.trim()
      if (!Boolean(searchTerm)) {
        if (that.recommendSearchResults) {
          that.recommendSearchResults.style.display = "block"
        }
      }
    })
    
    // 去掉失焦事件, 改为点击其他地方关闭
    // that.input.addEventListener("blur", function () {
    //   const searchTerm = that.input.value.trim()
      
    //   if(that.isMobile && !Boolean(searchTerm)) {
    //     if (that.recommendSearchResults) {
    //       that.recommendSearchResults.style.display = "none"
    //     }
    //     if (that.predictiveSearchResults) {
    //       that.predictiveSearchResults.innerHTML = ""
    //     }
    //   }
    // })
    document.querySelector('#toggle-mobile-menu').addEventListener("click", function (event) {
      if(that.input.contains(event.target) || that.predictiveSearchResults.contains(event.target)) return;

      const searchTerm = that.input.value.trim()
      
      if(that.isMobile && !Boolean(searchTerm)) {
        if (that.recommendSearchResults) {
          that.recommendSearchResults.style.display = "none"
        }
        if (that.predictiveSearchResults) {
          that.predictiveSearchResults.innerHTML = ""
        }
      }
    })

    that.mobileMenuCloseBtn.addEventListener("click", function () {
      if(that.isMobile){
        that.input.value = "";
        that.recommendSearchResults.style.display = "none";
        that.predictiveSearchResults.style.display = "none";
        if (that.predictiveSearchNoResults) {
          that.predictiveSearchNoResults.style.display = "none";
        }
      }
    });

    document.querySelector('#toggle-mobile-menu').addEventListener("click", function (event) {
      if(that.isMobile){
        if (!that.contains(event.target) && event.target !== that.input) {
          that.input.value = "";
          that.recommendSearchResults.style.display = "none";
          that.predictiveSearchResults.style.display = "none";
          if (that.predictiveSearchNoResults) {
            that.predictiveSearchNoResults.style.display = "none";
          }
        }
      }
    });
  }
  onChange() {
    const searchTerm = this.input.value.trim()
    if (!searchTerm.length) {
      this.close()
      if (this.predictiveSearchNoResults) {
        this.predictiveSearchNoResults.style.display = "none"
      }

      return
    }

    this.getSearchResults(searchTerm)

    // 创建一个自定义事件，携带 searchTerm 数据
    const event = new CustomEvent("search-input", {
      detail: { searchTerm } // 将 searchTerm 放入事件的 detail 属性中
    });

    // 分发事件
    document.dispatchEvent(event);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status)
          this.close()
          throw error
        }

        return response.text()
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, "text/html").querySelector("#shopify-section-predictive-search").innerHTML
        this.predictiveSearchResults.innerHTML = resultsMarkup
        if (!resultsMarkup) {
          this.close()
          this.predictiveSearchNoResults.style.display = "block"
          this.predictiveSearchNoResults.innerHTML = "<span>No results found for “" + this.input.value + "”</span>"
          return
        }
        this.open()
      })
      .catch((error) => {
        this.close()
        throw error
      })
  }

  open() {
    this.predictiveSearchResults.style.display = "block"
    this.input.focus()
    this.recommendSearchResults.style.display = "none"
  }

  close() {
    const that = this
    this.predictiveSearchResults.style.display = "none"
    const searchTerm = this.input.value.trim()
    if (!that.isMobile) {
      this.recommendSearchResults.style.display = "block"
    }else {
      this.recommendSearchResults.style.display = Boolean(searchTerm) ? "block" : "none";
    }
  }

  debounce(fn, wait) {
    let t
    return (...args) => {
      clearTimeout(t)
      t = setTimeout(() => fn.apply(this, args), wait)
    }
  }
}
customElements.define("predictive-search", PredictiveSearch)
